import React from 'react';
import {createIcon} from '../createIcon';

export const CardIcon = createIcon(
	<svg viewBox="0 0 24 24">
		<path d="M2 5.5C2 5.22386 2.22386 5 2.5 5H21.5C21.7761 5 22 5.22386 22 5.5V8H2V5.5Z" />
		<path d="M2 5.5C2 5.22386 2.22386 5 2.5 5H21.5C21.7761 5 22 5.22386 22 5.5V8H2V5.5Z" />
		<path d="M2 10H22V18.5C22 18.7761 21.7761 19 21.5 19H2.5C2.22386 19 2 18.7761 2 18.5V10ZM16.5 14C16.2239 14 16 14.2239 16 14.5V15.5C16 15.7761 16.2239 16 16.5 16H19.5C19.7761 16 20 15.7761 20 15.5V14.5C20 14.2239 19.7761 14 19.5 14H16.5Z" />
		<path d="M2 10H22V18.5C22 18.7761 21.7761 19 21.5 19H2.5C2.22386 19 2 18.7761 2 18.5V10ZM16.5 14C16.2239 14 16 14.2239 16 14.5V15.5C16 15.7761 16.2239 16 16.5 16H19.5C19.7761 16 20 15.7761 20 15.5V14.5C20 14.2239 19.7761 14 19.5 14H16.5Z" />
	</svg>,
);
